import React from 'react'

function about() {
  return (
    <>
    <div className='about' id='about'>
      <h4>INTRODUCTION</h4>
      <h1>OVERVIEW</h1>
      <p>A dedicated and skilled Full Stack Developer with experience in building responsive and dynamic web applications. Proficient in modern front-end technologies like React, HTML, CSS, JavaScript, Tailwind, and Bootstrap, as well as back-end development using Node , Express.js. Completed internships in  Node , Express.js, gaining hands-on expertise in real-world projects and coding best practices. Successfully delivered projects demonstrating strong problem-solving skills and an eye for detail. Passionate about crafting user-friendly interfaces and writing clean, efficient code. Eager to take on new challenges and continuously learn in a fast-paced environment.</p>
    </div>
    
    </>
  )
}

export default about
